<template>
    <div>

        <!--  <div class="spo-card rounded p-2 bg-orange-lighten-5">

            <div class="text-h6 text-darkblue font-weight-bold">Report de votre inscription en 2026</div>
            <v-chip variant="flat" :color="statusInscription == 'Annulée' ? 'red-darken-4' : 'green-darken-4'">Etat
                actuel
                de votre inscription : {{ statusInscription
                }}</v-chip>
            <div class="mt-2" v-if="statusInscription == 'Annulée'">
                <div>Suite à l'annulation de la course en 2025, sans action de votre part, <b>votre inscription sera
                        automatiquement annulée au 31 Décembre 2025</b> et
                    aucun remboursement ne sera effectué.</div>
                <div><u>Vous souhaitez participer à la prochaine édition ?</u> En cliquant sur le bouton ci-dessous,
                    votre
                    inscription sera reportée en 2026.</div>

                <div>A noter : si vous aviez
                    acheté la Pasta Party, veuillez noter qu'elle n'est pas reportée dans votre inscription 2026, car
                    des
                    frais avaient déjà été engagés.</div>
                <SportipsButton v-if="statusInscription == 'Annulée'" action-button icon="mdi-check" chevron
                    class="my-2" @onClick="keepInscription">Je souhaite conserver mon
                    inscription</SportipsButton>
            </div>
            <div class="mt-2" v-if="statusInscription == 'Reportée'">
                <div class="mt-2">Suite à l'annulation de la course en 2025, <b>vous avez fait le choix de reporter
                        votre inscription en 2026</b>.
                </div>
                <div>Vous avez changé d'avis et ne souhaitez pas participer à la prochaine édition? <b> Veuillez
                        indiquer si vous ne souhaitez pas conserver votre inscription</b> en cliquant sur le bouton
                    ci-dessous avant le 31 Décembre 2025.</div>
                <div>
                    Cela permettra de libérer votre place pour une autre personne. Aucun remboursement ne sera effectué.
                </div>
                <SportipsButton action-button icon="mdi-cancel" chevron class="my-2" @onClick="cancelInscription">Je ne
                    souhaite pas conserver mon
                    inscription</SportipsButton>
            </div>




            <div>L'organisateur vous remercie de votre compréhension.</div>
        </div> -->
    </div>
</template>

<script>
import UserService from '@/services/user.service';
export default {

    props: ["inscription"],
    computed: {
        statusInscription() {
            console.log(this.inscription);
            if (!this.inscription || !this.inscription.champs) {
                return 'Annulée';
            }
            const champ_keep_inscription = this.inscription.champs['tdr25_keep_inscription'];
            console.log(champ_keep_inscription);
            if (champ_keep_inscription && champ_keep_inscription == '1') {
                return 'Reportée';
            }
            return 'Annulée';

        }
    },
    methods: {
        async cancelInscription() {
            console.log('cancelInscription');
            await UserService.updateInscriptionChamp(this.inscription.id, 'tdr25_keep_inscription', '0');
            window.location.reload();
        },
        async keepInscription() {

            await UserService.updateInscriptionChamp(this.inscription.id, 'tdr25_keep_inscription', '1');
            window.location.reload();
        }
    }
}
</script>

<style lang="scss" scoped></style>